module.exports = __webpack_public_path__ + "static/media/3.9_preview.3db297c1.png";